import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-gjxt",
  "use": "icon-gjxt-usage",
  "viewBox": "0 0 50 46",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 46\" id=\"icon-gjxt\"><g><path d=\"M0 0h22.832v29.883H0z\" /><path stroke=\"#000\" stroke-width=\"3\" d=\"M27.69 17.281h19.832v26.883H27.69z\" /><path d=\"M26.19 0h22.832v12.423H26.19zM0 33.577h22.832V46H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol